import { createContext } from 'react';
const initialModalState = {
    showTarget: null,
    hideTarget: null,
    modals: []
};
const ModalContext = createContext(initialModalState);
export default ModalContext;
//# sourceMappingURL=ModalContext.js.map